/**
 * Created by Wojciech Szydlak on 02.02.2018.
 */

namespace Logic {

    interface StorageItem {
        value: any,
        timeout: number
    }

    interface StorageItems {
        [key: string]: StorageItem
    }

    interface Storages {
        [key: string]: GeocodeCacheStorage
    }

    class GeocodeCacheStorage {

        protected memory: StorageItems = {};

        public getItem(itemName: string): any {
            const item = this.memory[itemName] || null;
            return (item && item.value) || null;
        }

        public setItem(itemName: string, value: any, time = 3600): void {
            if (this.memory[itemName]) {
                clearTimeout(this.memory[itemName].timeout);
            }

            this.memory[itemName] = {
                value,
                timeout: setTimeout(() => {
                    this.deleteItem(itemName);
                }, time * 1000)
            };
        }

        public deleteItem(itemName) {
            if (this.memory[itemName]) {
                clearTimeout(this.memory[itemName].timeout);
                delete this.memory[itemName];
            }
        }
    }

    export class GeocodeCache {

        protected static storages: Storages = {};

        public static getStorage(storageName: string): GeocodeCacheStorage {
            if (!GeocodeCache.storages[storageName]) {
                GeocodeCache.storages[storageName] = new GeocodeCacheStorage();
            }
            return GeocodeCache.storages[storageName];
        }
    }
}